import { useApp } from '@/context/AppContext';
import Toast from '@/components/ui/Toast';
import Modal from '@/components/ui/Modal';
import SyncIndicator from '@/components/ui/SyncIndicator';
import UserMenu from '@/components/ui/UserMenu';
import MyDay      from '@/screens/mobile/MyDay';
import ActiveStop from '@/screens/mobile/ActiveStop';
import ChemLog    from '@/screens/mobile/ChemLog';
import Photos     from '@/screens/mobile/Photos';

const NAV_ITEMS = [
  { id: 'day',    icon: '🏠',  label: 'Home'   },
  { id: 'stop',   icon: '📋',  label: 'Stops'  },
  { id: 'chem',   icon: '🧪',  label: 'Chem'   },
  { id: 'photos', icon: '📸',  label: 'Photos' },
];

const SCREEN_MAP = {
  day:    MyDay,
  stop:   ActiveStop,
  chem:   ChemLog,
  photos: Photos,
};

function initialsFor(s) {
  return (s || '').split(/\s+/).filter(Boolean).map(p => p[0]).slice(0, 2).join('').toUpperCase() || '??';
}

export default function MobileLayout() {
  const { mobileScreen, setMobileScreen, setForceView, viewingTech, userEmail } = useApp();
  const navInitials = initialsFor(viewingTech || userEmail?.split('@')[0] || 'W O');

  const CurrentScreen = SCREEN_MAP[mobileScreen] || MyDay;

  return (
    <div className="mobile-shell">
      {/* Topbar */}
      <div className="topbar" style={{ padding: '0 14px' }}>
        <div className="wordmark" style={{ fontSize: 15 }}>
          <div className="wmark">W</div>
          PainterOps
        </div>
        <div className="topright" style={{ gap: 6 }}>
          <SyncIndicator compact />
          <button
            className="view-toggle"
            style={{ fontSize: 11, padding: '4px 9px' }}
            onClick={() => setForceView('desktop')}
          >
            Desktop
          </button>
          <UserMenu initials={navInitials} />
        </div>
      </div>

      {/* Main scrollable area */}
      <div className="mobile-main">
        <CurrentScreen />
      </div>

      {/* Bottom nav */}
      <div className="bottom-nav safe-bottom">
        {NAV_ITEMS.map(n => (
          <button
            key={n.id}
            className={`bnav${mobileScreen === n.id ? ' active' : ''}`}
            onClick={() => setMobileScreen(n.id)}
          >
            <div className="bnav-icon">{n.icon}</div>
            {n.label}
          </button>
        ))}
      </div>

      {/* Global overlays */}
      <Modal />
      <Toast />
    </div>
  );
}
